import { getJsonApiDataById } from "../jsonapi_helpers";

export const mapFileDatum = (item, included) => {
  if (!(item && item.data)) return null;
  if (!item.data.id && item.data.length === 0) return;

  const mapDatum = (itemId) => {
    const itemData = getJsonApiDataById(itemId, included);
    const { drupal_internal__fid, uri, filename, filesize } =
      itemData.attributes;
    return {
      fid: drupal_internal__fid,
      uuid: itemData.id,
      url: uri.url,
      fileName: filename,
      fileSize: filesize,
    };
  };

  return item.data.length > 0
    ? item.data.map((relatedItem) => mapDatum(relatedItem.id))
    : mapDatum(item);
};

export const mapFileResponse = (response) => {
  const itemData = response.data;
  const { drupal_internal__fid, uri, filename, filesize } = itemData.attributes;
  return {
    fid: drupal_internal__fid,
    uuid: itemData.id,
    url: uri.url,
    fileName: filename,
    fileSize: filesize,
  };
};
